// A seat's round avatar (the first letter of the name) in every card table; online a real player also gets a small
// badge: the country's flag, or a person for a guest without one, so the players stand out from the bots (owner
// 2026-10-29: "wcisnąć gdzieś flagę graczy, to też fajnie ich wyróżnia od botów"). Offline and for a bot: the letter.
import { initial, type SeatNames } from '../hearts/names';
import { flagUrl } from '../multiplayer/store';
import { sharpFlag } from '../options/assets';

/** The badge of a seat a bot plays for its player (away, gone, asleep): a robot in place of the flag, and the name
 *  stays the player's (owner 2026-11-02: "(bot)" after it doubled the brackets in "Gra: 130 (Gość-8731 (bot))"). */
export const BOT_BADGE = 'bot';

/** The badge of `seat` from the table's names: a flag code ('' = a guest), BOT_BADGE (a bot plays the player's seat),
 *  or null (a bot of the table; offline). */
export const seatFlag = (names: SeatNames | null | undefined, seat: number): string | null =>
  names?.benched?.[seat] ? BOT_BADGE : (names?.flags?.[seat] ?? null);

export function SeatAvatar({ name, flag }: { name: string; flag: string | null }) {
  return (
    <i className="ht-avatar" data-human={flag !== null || undefined}>
      {initial(name)}
      {flag === BOT_BADGE ? (
        <span className="ht-avatar__bot" aria-hidden="true" />
      ) : flag ? (
        <img className="ht-avatar__flag" src={sharpFlag(flagUrl(flag))} alt="" draggable={false} />
      ) : flag === '' ? (
        <span className="ht-avatar__guest" aria-hidden="true" />
      ) : null}
    </i>
  );
}
